import { Modal, Form, Input, Button, Space, message } from 'antd';
import axios from 'axios';
import { apiBasePath } from '../../../utils/constants';
import { useEffect, useState } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';

export const ModalSendEmail = ({ open, selectedRecord: record, handleCancel, loader, setLoader }) => {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await axios.post(
        `${apiBasePath}/invoice/send-email?oper_id=${record.oper_id}&recipients=${values.recipient.replace(/\s+/g, '')}`
      );
      messageApi.success('Correo electrónico enviado correctamente');
    } catch (error) {
      console.error('Error sending email:', error.response);
      messageApi.error('Error al enviar el correo electrónico');
    } finally {
      setLoading(false);
      setLoader({ ...loader, [record.oper_id]: false });
      handleCancel();
      form.resetFields();
    }
  };

  const getClientEmail = async () => {
    try {
      const response = await axios.get(`${apiBasePath}/customer/id/${record.oper_clie_id}`);
      form.setFieldsValue({ recipient: response.data.customer.clie_correo });
    } catch (error) {
      console.error('Error getting client email:', error.response);
    }
  };

  useEffect(() => {
    if (open) {
      getClientEmail();
    }
  }, [open]);

  return (
    <>
      {contextHolder}
      <Modal
        title="Enviar correo electrónico"
        open={open}
        onCancel={handleCancel}
        footer={
          <Space style={{ textAlign: 'right' }} size={16} align="center" justify="center" gap={16}>
            <Button onClick={handleCancel}>Cancelar</Button>
            <Button type="primary" onClick={() => form.submit()} loading={loading}>
              Enviar
            </Button>
          </Space>
        }>
        <Form form={form} onFinish={onFinish} requiredMark={true}>
          <Form.Item
            name="recipient"
            label="Correo electrónico"
            layout="vertical"
            validateTrigger="onBlur"
            tooltip={{ title: 'Admite múltiples correos. Sepáralos con “;”.', icon: <InfoCircleOutlined /> }}
            rules={[
              {
                required: true,
                message: 'Por favor ingresa un correo electrónico'
              }
            ]}>
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
